import PropTypes from "prop-types";

const ConfigProps = PropTypes.shape({
  amount_min: PropTypes.number,
  amount_max: PropTypes.number,
  default_amounts_in_dollars: PropTypes.shape({
    once: PropTypes.string,
    monthly: PropTypes.string,
  }),
  default_frequency: PropTypes.string,
  frequency_allowed_values: PropTypes.array,
  locale: PropTypes.string,
  Paypal_allowed: PropTypes.bool,
  Paypal_env: PropTypes.string,
  post_address_capture: PropTypes.bool,
  recaptcha_enabled: PropTypes.bool.isRequired,
  recaptcha_siteKey: PropTypes.string,
  region_code: PropTypes.string,
  region_currency_sign: PropTypes.string,
  region_home_country_code: PropTypes.string,
  Stripe_PublishableKey: PropTypes.string,
  suggested_amounts_in_dollars: PropTypes.shape({
    once: PropTypes.arrayOf(PropTypes.string),
    monthly: PropTypes.arrayOf(PropTypes.string),
  }),
  user_features: PropTypes.array,
});

const ConfigDefaultProps = {
  amount_min: 5,
  amount_max: 5000,
  default_amounts_in_dollars: {
    once: "100",
    monthly: "20",
  },
  default_frequency: "once",
  frequency_allowed_values: ["once", "monthly"],
  locale: "en-AU",
  Paypal_allowed: true,
  Paypal_env: "sandbox",
  post_address_capture: true,
  recaptcha_enabled: false,
  recaptcha_siteKey: "super-site-key",
  region_currency_sign: "¥",
  region_home_country_code: "DZ",
  Stripe_PublishableKey: "stripe_publishable_key",
  suggested_amounts_in_dollars: {
    once: ["30", "100"],
    monthly: ["30", "100"],
  },
  user_features: [],
};

export { ConfigProps, ConfigDefaultProps };
